import { Dialog } from 'primereact/dialog'
import { Image } from 'primereact/image'
import React from 'react'

export interface EventImageViewerProps {
  selectedImage: string | null
  setSelectedImage: (selectedImage: string | null) => void
}

const EventImageViewer = (props: EventImageViewerProps) => {
  const dialogHeader = () => {
    return (
      <div className='events-preview-header'>
        <i className='pi pi-image' />
        <span>Visualização da Imagem</span>
      </div>
    )
  }
  return (
    <Dialog
      visible={!!props.selectedImage}
      onHide={() => props.setSelectedImage(null)}
      style={{ width: '80vw', maxWidth: '1000px' }}
      header={dialogHeader}
      dismissableMask
      className='events-image-dialog'
    >
      <div className='events-image-preview-container'>
        <Image
          src={props.selectedImage || ''}
          alt='Detalhes do Evento'
          width='100%'
          preview
          zoomSrc={props.selectedImage || ''}
        />
      </div>
    </Dialog>
  )
}

export default EventImageViewer
